<template lang="pug">
.selection-error-message {{ message }}
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    message: {
      type: String,
      required: true,
    },
  },
});
</script>
<style scoped lang="scss">
.selection-error-message {
  margin-top: 0.25rem;
  padding: 0.5rem;
  font-size: small;
}
</style>
